import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=609c375d&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c375d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609c375d')) {
      api.createRecord('609c375d', component.options)
    } else {
      api.reload('609c375d', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=609c375d&scoped=true", function () {
      api.rerender('609c375d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/Tab.vue"
export default component.exports